import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import ClientForm from "@components/forms/ClientForm";

const ClientAddEdit = () => {
  const params = useParams()
  const { id: clientId } = params;

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`${!clientId ? 'Agregar' : 'Editar'} Cliente`}
      backUrl="/user/clients"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "clientForm",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <ClientForm
        formId="clientForm"
        id={clientId}
        saveRedirectUrl="/user/clients"
      ></ClientForm>

    </PageContainer>
  );
}

export default ClientAddEdit;
